import * as React from 'react'

export const MOBILE_BREAKPOINT = 768

const MOBILE_MEDIA = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`

function getServerSnapshot(serverHint?: boolean) {
  return serverHint ?? false
}

function getClientSnapshot() {
  return typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT
}

function subscribe(callback: () => void) {
  if (typeof window === 'undefined') return () => {}
  const mql = window.matchMedia(MOBILE_MEDIA)
  mql.addEventListener('change', callback)
  return () => mql.removeEventListener('change', callback)
}

/**
 * Returns true when viewport is below MOBILE_BREAKPOINT (768px).
 * Pass serverHint from loader (User-Agent based) to avoid layout shift on initial load.
 */
export function useIsMobile(serverHint?: boolean) {
  return React.useSyncExternalStore(subscribe, getClientSnapshot, () =>
    getServerSnapshot(serverHint),
  )
}
